import TableToolbar from '@rio-cloud/rio-uikit/TableToolbar';
import { ServiceOrderToolbarSearch } from './ServiceOrderToolbarSearch';
import { ServiceOrderCategoriesSelection } from './ServiceOrderCategoriesSelection';
import { ServiceOrderFilterModal } from './ServiceOrderFilterModal';
import { ReactElement } from 'react';
import { TableColumnSettings } from '../../../sharedComponents/table/TableColumnSettings';
import { TableViewOptions } from '../../../sharedComponents/TableViewOptions';

type ServiceOrderTableToolbarProps = {
    statusFilter: ReactElement;
    exportModal?: ReactElement;
};

export const ServiceOrderTableToolbar = ({ statusFilter, exportModal }: ServiceOrderTableToolbarProps) => {
    return (
        <TableToolbar>
            <div className="table-toolbar-container">
                <div className="table-toolbar-group-left">
                    <div className="table-toolbar-column">
                        <div className="btn-toolbar table-btn-toolbar">
                            <ServiceOrderCategoriesSelection />
                        </div>
                    </div>
                </div>
                <div className="table-toolbar-group-right">
                    <div className="table-toolbar-column table-toolbar-column-spacer min-width-300">{statusFilter}</div>
                    <div className="table-toolbar-column">
                        <ServiceOrderFilterModal />
                    </div>
                    <div className="table-toolbar-column">
                        <ServiceOrderToolbarSearch />
                    </div>
                    {exportModal && <div className="table-toolbar-column">{exportModal}</div>}
                    <div className="table-toolbar-column">
                        <TableViewOptions />
                    </div>
                    <div className="table-toolbar-column">
                        <TableColumnSettings />
                    </div>
                </div>
            </div>
        </TableToolbar>
    );
};
